<template>
    <div class="layout">
        <Header/>
        <Menu/>
        <router-view :style="{'margin-left': height + 'px'}" :class="'transition'"></router-view>
        <Footer/>
    </div>
</template>

<script>
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Menu from './Menu/Menu'

export default {
    name: 'layout',
    components: {
        Header,
        Footer,
        Menu
    },
    data() {
        return {
            height: 350,
            width: '100%'
        }
    },
    mounted() {
        this.$root.$on('collapse', (block) => {
            if (block) {
                this.height = 350
                this.width = window.innerWidth - this.height
            } else {
                this.height = 80
                this.width = window.innerWidth - this.height
            }
        })
    }
}
</script>

<style scoped>
.transition{
    transition: margin-left 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue